import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000, withCredentials: true });

// Auth is carried by an httpOnly session cookie (set by the backend on login/
// register/Google-session). We intentionally do NOT read tokens from JS storage
// to avoid XSS token theft; `withCredentials` sends the cookie automatically.

export const fetchCategories = async () => {
  const { data } = await client.get("/categories");
  return data;
};

export const fetchProducts = async (params = {}) => {
  const { data } = await client.get("/products", { params });
  return data;
};

export const fetchProduct = async (id) => {
  const { data } = await client.get(`/products/${id}`);
  return data;
};

export const fetchRelated = async (id) => {
  const { data } = await client.get(`/products/${id}/related`);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await client.post("/orders", payload);
  return data;
};

export const fetchOrder = async (orderId) => {
  const { data } = await client.get(`/orders/${orderId}`);
  return data;
};

export const fetchMyOrders = async () => {
  const { data } = await client.get("/orders/mine");
  return data;
};

export const createPrescription = async (payload) => {
  const { data } = await client.post("/prescriptions", payload);
  return data;
};

// ---------------- Admin (product management) ----------------
const adminHeaders = (key) => ({ headers: { "X-Admin-Key": key } });

export const adminAddProduct = async (key, payload) => {
  const { data } = await client.post("/products", payload, adminHeaders(key));
  return data;
};

export const adminDeleteProduct = async (key, id) => {
  const { data } = await client.delete(`/products/${id}`, adminHeaders(key));
  return data;
};

// ---------------- Payments (Razorpay) ----------------
export const fetchPaymentConfig = async () => {
  const { data } = await client.get("/payments/config");
  return data;
};

export const createPaymentOrder = async (amount) => {
  const { data } = await client.post("/payments/create-order", { amount });
  return data;
};

export const verifyPayment = async (payload) => {
  const { data } = await client.post("/payments/verify", payload);
  return data;
};

// ---------------- Auth ----------------
export const apiRegister = async (payload) => {
  const { data } = await client.post("/auth/register", payload);
  return data;
};

export const apiLogin = async (payload) => {
  const { data } = await client.post("/auth/login", payload);
  return data;
};

export const apiMe = async () => {
  const { data } = await client.get("/auth/me");
  return data;
};

export const apiLogout = async () => {
  const { data } = await client.post("/auth/logout");
  return data;
};

export const apiExchangeSession = async (sessionId) => {
  const { data } = await client.post(
    "/auth/session",
    {},
    { headers: { "X-Session-ID": sessionId } }
  );
  return data;
};

export default client;
